import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { setLanguage } from "@/i18n";
import { langForCountry } from "@/i18n/countries";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const USER_TYPE_LABELS = {
  citizen: "Citizen",
  ngo: "NGO",
  news_organisation: "News Organisation",
  research_organisation: "Research Organisation",
  company: "Company",
  association: "Association / Group of Interest",
  elected_representative: "Political Representative",
  public_official: "Public Official",
};

export const NEEDS_VERIFICATION = ["ngo", "news_organisation", "research_organisation", "company", "association", "elected_representative", "public_official"];

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  const refresh = async () => {
    try { const r = await api.get("/auth/me"); setUser(r.data); applyUserLanguage(r.data); return r.data; }
    catch { setUser(false); }
  };
  useEffect(() => { refresh().finally(() => setReady(true)); }, []);

  // Auto-set UI language from the user's country, unless they chose one manually.
  const applyUserLanguage = (u) => {
    if (!u) return;
    if (localStorage.getItem("lang_manual") === "1") return;
    const lng = langForCountry(u.location?.country);
    if (lng) setLanguage(lng);
  };

  const login = async (email, password) => { const { data } = await api.post("/auth/login", { email, password }); setUser(data); applyUserLanguage(data); return data; };
  const register = async (payload) => { const { data } = await api.post("/auth/register", payload); setUser(data); applyUserLanguage(data); return data; };
  const logout = async () => { await api.post("/auth/logout"); localStorage.removeItem("lang_manual"); setUser(false); };

  return <AuthContext.Provider value={{ user, ready, login, register, logout, refresh }}>{children}</AuthContext.Provider>;
}
